<template>
  <div v-if="items" class="product-block" :class="additionalClass">
    <div class="product-block__inner">
      <product-links :links="items" />
    </div>
  </div>
</template>

<script>
  import ProductLinks from '~/components/product/ProductLinks.vue';

  export default {
    components: {
      ProductLinks
    },
    props: {
      additionalClass: {
        default: '',
        type: String
      },
      items: {
        default() {
          return [];
        },
        type: Array
      },
      // we get these props but don't use them in current block type
      publishedTo: {
        default: undefined,
        type: [Number, String]
      },
      nodes: {
        default() {
          return [];
        },
        type: Array
      },
      title: {
        default: '',
        type: String
      },
      content: {
        default() {
          return {};
        },
        type: Object
      },
      video: {
        default() {
          return {};
        },
        type: Object
      },
      placeholder: {
        default() {
          return {};
        },
        type: Object
      },
      images: {
        default() {
          return [];
        },
        type: Array
      }
    }
  };
</script>
